<template>
  <main>
    <marketing-sms-form v-if="smsData"
                        :item="smsData" />
  </main>
</template>

<script>
import MarketingSmsForm from "@components/modules/marketing/sms/generic/form/MarketingSmsForm";
import EventBus from "@packages/event-bus";

export default {
  components: {
    MarketingSmsForm,
  },

  data() {
    return {
      smsData: undefined,
    };
  },

  created() {
    this.fetchSms();
  },

  computed: {},

  methods: {
    async fetchSms() {
      const sms = await this.$api.smsMessage.get({
        smsId: this.$route.params.smsId,
      });

      this.smsData = sms;

      EventBus.$emit("EMIT_SMS_EDIT_DATA", sms);
    },
  },

  mixins: [],
};
</script>

<style lang="scss" scoped>
</style>
